module.exports = __webpack_public_path__ + "img/NewsCenterDetails_pic2.1de8d862.png";